import { getIn } from 'formik';
import React from 'react';

import { WipConfig } from '../../types';
import {
  CreditAgreement,
  isPropertyContainerType,
  isPropertyType,
} from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/common';
import { Property } from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/property/Property';
import { PropertyContainer } from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/property/PropertyContainer';

type PropertyViewProps = {
  headers: (
    | keyof CreditAgreement.DomainEntity.Property
    | keyof CreditAgreement.DomainEntity.PropertyContainer
  )[];
  basePropertyKey: string;
  property:
    | CreditAgreement.DomainEntity.PropertyContainer
    | CreditAgreement.DomainEntity.Property;
  propertyKey: string;
  wipConfig?: WipConfig;
  idx?: number;
  columnWidth?: number;
};
export const PropertyView = ({
  headers,
  property,
  propertyKey,
  wipConfig,
  basePropertyKey,
  idx,
  columnWidth,
}: PropertyViewProps) => {
  if (!property) return null;

  if (isPropertyContainerType(property.type)) {
    return (
      <PropertyContainer
        headers={headers}
        basePropertyKey={basePropertyKey}
        propertyKey={propertyKey}
        // @ts-ignore
        property={property}
        wipConfig={wipConfig}
        isOptional={
          !!(
            wipConfig &&
            !getIn(wipConfig.wipShell, `${basePropertyKey}.${propertyKey}`)
          )
        }
        columnWidth={columnWidth}
      />
    );
  }
  if (isPropertyType(property.type)) {
    return (
      <Property
        headers={headers}
        basePropertyKey={basePropertyKey}
        propertyKey={propertyKey}
        // @ts-ignore
        property={property}
        wipConfig={wipConfig}
        isOptional={
          !!(
            wipConfig &&
            !getIn(wipConfig.wipShell, `${basePropertyKey}.${propertyKey}`)
          )
        }
        idx={idx}
        columnWidth={columnWidth}
      />
    );
  }
  throw Error(`Expected to receive a valid property or property container`);
};
